import { createArray } from 'helpers';
import * as setup from 'setup';
import Danger from './Danger';

export default class DangerLawnmower extends Danger {

    textureRotation = Math.PI;

    constructor(gameState: GameState, props?: DangerProps, state?: any) {
        super(gameState, 'lawnmower', setup.dangers.lawnmower, {
            ...props,
            movingTextures: createArray(4, i => `danger/lawnmower/danger-lawnmower-moving-${i + 1}.png`),
        }, state);
    }

    init = () => {
        this.findTarget();
        this.playSound('danger-lawnmower', 1, true);
    }

    findTarget = () => {
        // Get any closest Ant
        const targets = [
            ...this.gameState.entities.ants.explorers.active,
            ...this.gameState.entities.ants.warriors.active,
            ...this.gameState.entities.ants.workers.active,
            ...this.gameState.entities.dangers.antWarriors.active,
            ...this.gameState.entities.dangers.antWorkers.active,
        ];
        this.target = this.getClosestTarget(targets, this.setup.searchDistance);

        // If close enough, attack, otherwise move again
        if (this.isCloseToTarget(this.target)) {
            this.attackTarget(this.target, this.findTarget);
        } else if (this.target) {
            this.moveToTarget(this.target, this.findTarget);
        } else {
            this.wanderTo(this.cell, 0, this.findTarget);
        }
    }

}